const shortTextMaxLength = 255;
const longTextMaxLength = 100000000;
const hasValue = value => !!value;

// TODO: if we can detect reference data override, we should disallow empty strings
//const hasValue = value => value !== null && !!String(value).trim()

const hasRequiredValue = previewEntry => {
  // TODO: We should have a shared place to store standard error messages...
  const errorMessage = 'This field is required';
  const {
    required,
    value
  } = previewEntry;
  if (required && !hasValue(value)) {
    return errorMessage;
  }
};

// TODO: This is an example of a custom validation, this isn't "real"
const isToLong = previewEntry => {
  const {
    value,
    original_type_id
  } = previewEntry;
  const maxLength = `${original_type_id}` == '0' ? shortTextMaxLength : longTextMaxLength;
  const errorMessage = `The maximum length for this field is ${maxLength}`;
  if (value && value.length > maxLength) {
    return errorMessage;
  }
};
export default [{
  validation: hasRequiredValue,
  type: 'required'
}, {
  validation: isToLong,
  type: 'format'
}];